import { Typography } from '@coolblue-development/freddy';
import { useGetCollectionTitle } from '@hooks/collectionHooks';

import { ProductType } from '../Collection.types';

type CollectionTitleProps = {
  title: string;
  productType?: ProductType | null;
  variant?: 'default' | 'entrance' | 'small';
};

export const CollectionTitle = ({
  title,
  productType,
  variant = 'default'
}: CollectionTitleProps) => {
  const isEntranceTitle = variant === 'entrance';
  const isDefaultTitle = variant === 'default';

  const collectionTitle = useGetCollectionTitle(title, productType, isEntranceTitle);

  const fontWeight = (() => {
    switch (variant) {
      case 'small':
        return 600;
      case 'entrance':
        return 400;
      default:
        return 700;
    }
  })();

  return (
    <>
      {collectionTitle && (
        <Typography
          mb={isEntranceTitle ? 0 : 200}
          fontWeight={fontWeight}
          {...(isDefaultTitle && { variant: 'h4' })}
          {...(isEntranceTitle && { color: 'additional' })}
          sx={{ whiteSpace: 'nowrap' }}
        >
          {collectionTitle}
        </Typography>
      )}
    </>
  );
};
